import { render } from "./ImportChoiceTypeStep.vue?vue&type=template&id=f82bcefe&scoped=true"
import script from "./ImportChoiceTypeStep.vue?vue&type=script&lang=js"
export * from "./ImportChoiceTypeStep.vue?vue&type=script&lang=js"

import "./ImportChoiceTypeStep.vue?vue&type=style&index=0&id=f82bcefe&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f82bcefe"]])

export default __exports__